import React, { useState } from 'react';
import { ConsultationStatusHistoryEntry } from '../store/slices/consultationsSlice';
import { statusLabel } from '../constants/consultationStatus';
import { formatDateDisplay } from '../utils/dateUtils';
import './ConsultationStatusHistory.css';

interface Props {
  items?: ConsultationStatusHistoryEntry[];
}

/**
 * Collapsible, read-only log of a consultation's status changes (newest first).
 * Default collapsed. See docs/specs/consultation-status-lifecycle.md.
 */
const ConsultationStatusHistory: React.FC<Props> = ({ items }) => {
  const [open, setOpen] = useState(false);
  const history = items || [];

  return (
    <section className="consultation-edit__card status-history">
      <button
        type="button"
        className="status-history__header"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className="status-history__chevron">{open ? '▾' : '▸'}</span>
        <span>Status History ({history.length})</span>
      </button>

      {open && (
        history.length === 0 ? (
          <p className="status-history__empty">No status changes recorded yet.</p>
        ) : (
          <ul className="status-history__list">
            {history.map((h) => (
              <li key={h.id} className="status-history__row">
                <span className="status-history__time">{formatDateDisplay(h.createdAt, true)}</span>
                <span className="status-history__change">
                  {h.fromStatus ? statusLabel(h.fromStatus) : '(created)'} → {statusLabel(h.toStatus)}
                </span>
                {h.changedByName && <span className="status-history__actor">{h.changedByName}</span>}
              </li>
            ))}
          </ul>
        )
      )}
    </section>
  );
};

export default ConsultationStatusHistory;
